import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useAuth } from 'app/frontend/base/config/context/auth'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import Card from 'app/frontend/base/components/Card'

const GuildTeamCard = ({ team }: { team: wowaudit.TeamReference }) => {
  const { t } = useTranslation()
  const { accessLevel } = useAuth()

  const ctaButton = (
    <Button
      variant='outline'
      size='sm'
      className={
        accessLevel === 'none'
          ? 'cursor-not-allowed opacity-50 hover:bg-unset'
          : ''
      }
    >
      {t('shared.view')}
    </Button>
  )

  return (
    <Card
      className='py-3 px-4 flex items-start justify-between gap-6 flex-wrap'
      key={team.id}
    >
      <div>
        {accessLevel === 'none' ? (
          <h3 className='font-semibold text-lg'>{team.name}</h3>
        ) : (
          <Link to={team.path}>
            <h3 className='font-semibold text-lg'>{team.name}</h3>
          </Link>
        )}
        <p
          className={
            team.description ? 'whitespace-pre-wrap' : 'opacity-50 italic'
          }
        >
          {team.description || t('shared.no-description')}
        </p>
      </div>

      <div className='flex gap-4 items-center justify-between whitespace-nowrap'>
        <span>{team.characterAmount} members</span>
        {accessLevel === 'none' ? (
          <Tooltip>
            <TooltipTrigger className='cursor-not-allowed' asChild>
              {ctaButton}
            </TooltipTrigger>
            <TooltipContent side='left'>
              {t('dashboard.guild.no-team-access')}
            </TooltipContent>
          </Tooltip>
        ) : (
          <Link to={team.path}>{ctaButton}</Link>
        )}
      </div>
    </Card>
  )
}

export default GuildTeamCard
